import { Dropdown, Col, Row, Space, Typography, Modal, message } from "antd";
import { useState } from "react";
import LabelsView from "../components/labels/LabelsView";
import { Guid } from "guid-typescript";
import Loader from "../controls/Loader";
import { SearchQuery } from "../code/search-query/search-query";
import { getLabelsExport } from "../repository/data.repository";
import LabelsFormDialog from "../components/labels/LabelsFormDialog";
import { Label } from "../repository/data.default";
import { LabelsForm } from "../components/labels/LabelsView.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function LabelsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [labelInputMode, setLabelInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [labelInputOpen, setLabelInputOpen] = useState(false);
  const [labelInputValues, setLabelInputValues] = useState<LabelsForm>(
    {} as any,
  );
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onLabelInputOpen(
    mode: "add" | "update" | "delete",
    values?: Label,
  ): void {
    setLabelInputMode(mode);
    setLabelInputOpen(true);
    setLabelInputValues(
      values
        ? {
            ...values,
          }
        : ({} as any),
    );
  }

  function onLabelInputFinish(): void {
    setLabelInputOpen(false);
    setLabelInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onLabelInputClose(): void {
    setLabelInputOpen(false);
    setLabelInputValues({} as any);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading labels export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getLabelsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Labels
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("Labels", "create")}

            className={`${!permissions.can("Labels", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("Labels", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onLabelInputOpen("add")}
          >
            Add Label
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <LabelsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onLabelInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <LabelsFormDialog
        mode={labelInputMode}
        open={labelInputOpen}
        initialValues={labelInputValues}
        onFinish={onLabelInputFinish}
        onCancel={onLabelInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default LabelsPage;
